import HttpUtil, { Config } from '@/utils/service/http';
import { interfaceEnum } from '@/enums/interfaceEnum';
import { getUnixTime } from '@/utils';
import { useUserStore } from '@/store/modules/user';
export default class MainService extends HttpUtil {
    /**
     * 图片识别
     * @returns 
     */
    static async imageRecognize(base64Data: string, config?: Config) {
        return this.post({
            url: interfaceEnum.Image,
            params: {
                imageBase64: base64Data,
                timestamp: getUnixTime(),
            },
            errors: false,
            ...config,
        });
    }

    /**
     * 文字识别
     */
    static async textRecognize(base64Data: string, config?: Config): Promise<{
        recognizeResult: {
            log_id: number,
            words_result_num: number,
            words_result: { words: string }[]
        }
    }> {
        return this.post({
            url: interfaceEnum.Text,
            params: {
                imageBase64: base64Data,
                timestamp: getUnixTime(),
            },
            errors: false,
            ...config,
        })
    }

    /**
     * 手势识别
     */
    static async gestureRecognize(base64Data: string, config?: Config): Promise<{
        recognizeResult: {
            log_id: number;
            result_num: number;
            result: Array<{
                classname: string;
                probability: number;
                top: number;
                left: number;
                width: number;
                height: number;
            }>
        }
    }> {
        return this.post({
            url: interfaceEnum.Gesture,
            params: {
                imageBase64: base64Data,
                timestamp: getUnixTime(),
            },
            ...config,
        })
    }

    /**
     * 获取 occ 授权
     * @returns 
     */
    static async getAuthToken(config?: Config): Promise<{
        accessToken: string;
        expire: number;
    }> {
        return this.get({
            url: interfaceEnum.Auth,
            params: {
                id: import.meta.env.VITE_OCC_HK_H5_PLATFORM,
                timestamp: getUnixTime(),
            },
            ...config,
        })
    }

    /**
     * 上报埋点
     */
    static async report(payload: {
        name: string;
        page: string;
        occurredAt?: string;
    },  config?: Config) {
        return this.post({
            url: interfaceEnum.Report,
            params: {
                id: import.meta.env.VITE_OCC_HK_H5_PLATFORM,
                timestamp: getUnixTime(),
                data: {
                    sdk: import.meta.env.VITE_OCC_HK_H5_PLATFORM, // sdk 类型
                    source: import.meta.env.VITE_OCC_HK_H5_PLATFORM, // 来源渠道
                    openId: useUserStore().finger, // 浏览器指纹
                    ...payload
                }
            },
            ...config,
        });
    }
}